module.exports = __webpack_public_path__ + "img/question14c3.59a0c6e9.png";